import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h6',
  styleUrl: 'signet-h6.scss',
  shadow: true,
})
export class SignetH6 {
  render() {
    return <h6><slot /></h6>;
  }
}